import type { ReactElement } from 'react'

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { useToastStore } from '@/stores/toast.store'

/**
 * Renders every toast in the Zustand store. Mounted once in `App`, so any
 * module — including the Axios interceptor — can raise a toast via `toast.*`.
 */
export function Toaster(): ReactElement {
  const toasts = useToastStore((state) => state.toasts)
  const dismiss = useToastStore((state) => state.dismiss)

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map(({ id, title, description, variant, durationMs }) => (
        <Toast
          key={id}
          variant={variant}
          duration={durationMs}
          onOpenChange={(open) => {
            if (!open) dismiss(id)
          }}
        >
          <div className="grid gap-1">
            <ToastTitle>{title}</ToastTitle>
            {description ? <ToastDescription>{description}</ToastDescription> : null}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
